import React from 'react';

interface IProps extends IClass {}

const StdInterpunct: React.FC<IProps> = ({ className }) => {
    return <span className={className}>{' · '}</span>;
};

export default StdInterpunct;
